import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRealtyStore } from '../../../../stores/realty-store';
import { useId } from 'react';
import {
  KOSICEREAL_REALTY_FILTER_RECIPE,
  type RealtyFilterTemplateSetting,
} from '../realty-filter-recipe';
import styles from '../realty-filter.module.css';
import { RealtyFilterCheckbox } from './utils/realty-filter-checkbox';

type RealtyFilterNumberOfRoomsProps = {
  templateSetting?: RealtyFilterTemplateSetting;
};

export const RealtyFilterNumberOfRooms = ({ templateSetting }: RealtyFilterNumberOfRoomsProps) => {
  const { t } = useTranslations();
  const { filter, setFilter } = useRealtyStore();
  const instanceId = useId();
  const headingId = `${instanceId}-realty-filter-rooms-heading`;

  if (templateSetting && !templateSetting.enabled) {
    return null;
  }

  const options = KOSICEREAL_REALTY_FILTER_RECIPE.roomOptions.map(option => ({
    id: option.value,
    translationKey: option.translationKey,
    name: t(option.translationKey),
  }));

  if (options.some(option => option.name === option.translationKey)) {
    return null;
  }

  const selectedRooms = filter.number_of_rooms ?? [];
  const isSelected = (roomValue: number) => selectedRooms.includes(roomValue);
  const handleFilterUpdate = (roomValue: number) => {
    const nextRooms = isSelected(roomValue)
      ? selectedRooms.filter(value => value !== roomValue)
      : [...selectedRooms, roomValue].sort((left, right) => left - right);

    setFilter({ number_of_rooms: nextRooms.length > 0 ? nextRooms : undefined });
  };

  return (
    <div className={styles.fieldGroup} style={{ order: templateSetting?.order }}>
      <section className={styles.section} aria-labelledby={headingId}>
        <h2 id={headingId} className={styles.heading}>
          {t('text3657')}
        </h2>
        <div className={styles.options}>
          {options.map(option => (
            <RealtyFilterCheckbox
              key={option.id}
              item={option}
              isSelected={isSelected}
              handleFilterUpdate={handleFilterUpdate}
              filterKey="number_of_rooms"
              idPrefix={`${instanceId}-realty-filter-room`}
            />
          ))}
        </div>
      </section>
      <Separator className={styles.separator} />
    </div>
  );
};
